<template>
    <div>
        <p>{{ this.countdownMessage }}</p>
    </div>
</template>

<script>
export default {
  props: {
    onCountdownFinished : {
        type : Function,
        required : true
    }
  },
  data() {
    return{
        countdown : 50
    }
  },
  computed: {
    countdownMessage(){
        return this.$t("loginKeyExpirationTime").replace("{value}", `${this.countdown}`)
    }
  },
  methods: {
    startCountdown(){
        setInterval(() => {
            if(this.countdown > 0){
              this.countdown--
            }
        }, 1000);
    }
  },
  created() {
    this.startCountdown()
  },
  watch: {
    countdown : function(){
        if(this.countdown == 0){
            this.onCountdownFinished()
        }
    },
    immediate: true
  }
}
</script>

<style>
</style>
